import { Textbox } from 'fabric';
import type { SobreimpresoCreateConfig, SobreimpresoTextbox } from './types';
import { SOBREIMPRESO_FACTORY_DEFAULTS } from './defaults';
import { initSobreimpreso } from './init';

export function createSobreimpreso(cfg: SobreimpresoCreateConfig): SobreimpresoTextbox {
  const D = SOBREIMPRESO_FACTORY_DEFAULTS;

  const s = new Textbox(cfg.text, {
    originX: 'center',
    originY: 'center',
    left: cfg.left,
    top: cfg.top,
    width: cfg.width,
    fill: cfg.textFill,
    fontFamily: cfg.fontFamily,
    fontSize: cfg.fontSize,
    fontWeight: cfg.fontWeight ?? D.fontWeight,
    fontStyle: cfg.fontStyle ?? D.fontStyle,
    textAlign: cfg.textAlign ?? D.textAlign,
    strokeWidth: 0,
    objectCaching: false
  }) as SobreimpresoTextbox;

  s.sobreimpreso = {
    fill: cfg.fill,
    stroke: cfg.stroke ?? D.stroke,
    strokeWidth: cfg.strokeWidth ?? D.strokeWidth,
    borderRadius: cfg.borderRadius ?? D.borderRadius,
    paddingX: cfg.paddingX ?? D.paddingX,
    paddingY: cfg.paddingY ?? D.paddingY,
    minHeight: cfg.height ?? D.minHeight
  };

  // Textbox constructor already ran initDimensions without meta — re-wrap now.
  s.initDimensions();
  initSobreimpreso(s);
  return s;
}
